/**
 * 全屏布局指令
 * 用法：在页面根元素上使用 v-fullscreen
 * 作用：自动清除 #app 的 padding-bottom，并在组件销毁时恢复
 */
export var fullscreenDirective = {
  inserted(el) {
    var appEl = document.getElementById('app')
    if (appEl) {
      el._originalPaddingBottom = appEl.style.paddingBottom || ''
      appEl.style.paddingBottom = '0'
    }
  },
  unbind(el) {
    var appEl = document.getElementById('app')
    if (appEl && el._originalPaddingBottom !== undefined) {
      appEl.style.paddingBottom = el._originalPaddingBottom
    }
  }
}
